import React from 'react'
import FileItem from '../FileItem'

const FileList = ({ files, removeHandler }) => {
    const deleteFileHandler = (filename) => {
        removeHandler(filename)
    }
    return (
        <div className="file_list">
            <ul className="file-list">
                {
                    files && files.map(file => <FileItem key={file.name} file={file} deleteFile={deleteFileHandler} />)
                }
            </ul>
        </div>
    )
}

export default FileList